import Quill from 'quill';
import utils from './utils';
Quill.debug(false);
const Inline = Quill.import('blots/inline');
var Delta = Quill.import('delta');
var Clipboard = Quill.import('modules/clipboard');
class PlainClipboard extends Clipboard {
  onPaste(e) {
    e.preventDefault();
    const range = this.quill.getSelection();
    const text = utils.parseJSONForTextValue(
      e.clipboardData.getData('text/plain'),
    );
    if (typeof text === 'string') {
      const format = this.quill.getFormat();
      const delta = new Delta()
        .retain(range.index)
        .delete(range.length)
        .insert(text, format);

      const index = text.length + range.index;
      const length = 0;
      this.quill.updateContents(delta, 'user');
      this.quill.setSelection(index, length, 'silent');
      this.quill.scrollIntoView();
    }
  }
}
Quill.register('modules/clipboard', PlainClipboard, true);

//

class FontWeightBlot extends Inline {
  static formats(domNode) {
    return domNode.getAttribute('fontWeight');
  }

  static create(value) {
    const node = super.create();
    node.setAttribute('fontWeight', value);
    return node;
  }
}
FontWeightBlot.blotName = 'fontWeight';
FontWeightBlot.tagName = 'strong';
Quill.register(FontWeightBlot);

class FontStyleBlot extends Inline {
  static formats(domNode) {
    return domNode.getAttribute('fontStyle');
  }

  static create(value) {
    const node = super.create();
    node.setAttribute('fontStyle', value);
    return node;
  }
}
FontStyleBlot.blotName = 'fontStyle';
FontStyleBlot.tagName = 'fontStyle';
Quill.register(FontStyleBlot);

class StyleCaseBlot extends Inline {
  static formats(domNode) {
    return domNode.getAttribute('styleCase');
  }

  static create(value) {
    const node = super.create();
    node.setAttribute('styleCase', value);
    return node;
  }
}
StyleCaseBlot.blotName = 'styleCase';
StyleCaseBlot.tagName = 'styleCase';
Quill.register(StyleCaseBlot);

// FILL COLOR
class fillBlot extends Inline {
  static formats(domNode) {
    return domNode.getAttribute('fill');
  }

  static create(value) {
    const node = super.create();
    node.setAttribute('fill', value);
    return node;
  }
}
fillBlot.blotName = 'fill';
fillBlot.tagName = 'fill';
Quill.register(fillBlot);

class fontFamilyBlot extends Inline {
  static formats(domNode) {
    return domNode.getAttribute('fontFamily');
  }

  static create(value) {
    const node = super.create();
    node.setAttribute('fontFamily', value);
    return node;
  }
}
fontFamilyBlot.blotName = 'fontFamily';
fontFamilyBlot.tagName = 'fontFamily';
Quill.register(fontFamilyBlot);

// underline
class underlineBlot extends Inline {
  static formats(domNode) {
    return JSON.parse(domNode.getAttribute('underline'));
  }

  static create(value) {
    const node = super.create();
    node.setAttribute('underline', value);
    return node;
  }
}
underlineBlot.blotName = 'underline';
underlineBlot.tagName = 'underline';
Quill.register(underlineBlot);

// linethrough
class linethroughBlot extends Inline {
  static formats(domNode) {
    return JSON.parse(domNode.getAttribute('linethrough'));
  }

  static create(value) {
    const node = super.create();
    node.setAttribute('linethrough', value);
    return node;
  }
}
linethroughBlot.blotName = 'linethrough';
linethroughBlot.tagName = 'linethrough';
Quill.register(linethroughBlot);

export default Quill;
